import { render, staticRenderFns } from "./OrderAddDialog.vue?vue&type=template&id=475a14c6&scoped=true"
import script from "./OrderAddDialog.vue?vue&type=script&lang=js"
export * from "./OrderAddDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderAddDialog.vue?vue&type=style&index=0&id=475a14c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475a14c6",
  null
  
)

export default component.exports